import React, { useMemo } from "react";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import styles from "../../../styles/sass/about_us.module.scss";
import constants from "../../../utils/Constants";
import BannerInner from "../../common-components/bannerinner/BannerInner";
import bannerImage from "../../../../public/assets/images/banner-img-top1.jpg";
import Overview from '../../common-components/overview/Overview';
import { overviewData, sliderThumbData } from '../../../other-object/ObjAccordion';
import SliderThumb from "../../common-components/sliderfull/SliderThumb";

const { ABOUT_US_FOLDS } = constants


const About = () => {
  const { cmsMap, boards } = useSelector((state) => state?.cms);
  const cmsBoard = useMemo(
    () => boards?.[JSON.stringify({ type: "AboutUs" })],
    [boards]
  );

  const settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
      autoplaySpeed: 6000,
    }),
    []
  );

  return (
    <>

      <BannerInner title={"About us"} imageSrc={bannerImage} />

      {ABOUT_US_FOLDS.map(fold => {
        const { _id, Component } = fold
        const mCMS = cmsMap[_id];

        if(mCMS?.active) {
          return <Component key={_id} data={mCMS} />
        }
      })}

      {/* <Overview data={overviewData} />
      <SliderThumb data = {sliderThumbData}/>
      <Overview orientation={"right"} data={overviewData} /> */}
      {/* <Row className={styles["container"]}>
        <Col className={styles["--left-container"]} xs={0} sm={0} xl={12} />

        <Col className={styles["--right-container"]} xs={24} sm={24} xl={12}>
          <Slider {...settings} className={styles["slider-container"]}>
            {cmsBoard?.list?.map((id, i) => {
              const tab = cmsMap?.[id];

              return (
                <Col key={id} className={styles["content-container"]}>
                  <h1>{tab?.name}</h1>

                  <Col
                    className={styles["description"]}
                    dangerouslySetInnerHTML={{ __html: tab?.description }}
                  />
                </Col>
              );
            })}
          </Slider>
        </Col>
      </Row> */}
    </>
  );
};

export default React.memo(About);
